import * as React from 'react';
import { Form, Row, Col, Button } from 'react-bootstrap';
import autobind from 'autobind-decorator';

import patchData from 'Utils/PatchData';
import displayGlobalMessage from 'Utils/DisplayGlobalMessage';


export interface IVideoContentProps {
    content: any;
    videoId: string;
    title: string;
    saveCallback: any;
    is_editable: any;
}

export interface IVideoContentState {
    showForm: boolean;
}

export default class VideoContent extends React.Component<IVideoContentProps, IVideoContentState> {
    constructor(props: IVideoContentProps) {
        super(props);

        this.state = {
            showForm: false
        }
    }
    @autobind
    public onSave(event) {
        event.preventDefault();
        event.stopPropagation();
        const url = `/video/api/video/${this.props.videoId}/?format=json`;
        const form = event.currentTarget;
        let data = {
            title: form["title"].value,
            content: form["description"].value
        };
        patchData(url, data)
            .then(response => {
                this.props.saveCallback(data.title, data.content);
                displayGlobalMessage("Description Saved Successfully", "success");
                this.setState({showForm:false});
            })
            .catch(err => {
                console.log(err)
                displayGlobalMessage("Description Save Failed", "error");
            });
    }

    public render() {
        return (
            this.state.showForm ?
                (
                    <Form onSubmit={this.onSave}>
                        <Form.Group as={Row} controlId="title">
                            <Form.Label>
                                Title
                            </Form.Label>

                            <Form.Control required type="text" defaultValue={this.props.title} />

                        </Form.Group>

                        <Form.Group as={Row} controlId="description">
                            <Form.Label>
                                Description
                        </Form.Label>

                            <Form.Control as="textarea" rows={4} defaultValue={this.props.content} />

                        </Form.Group>
                        <Form.Group as={Row}>
                            <Col sm={{ span: 4, offset: 2 }}>
                                <Button variant="success" type="submit">Save</Button>
                            </Col>
                            <Col sm={{ span: 4, offset: 2 }}>
                                <Button variant="danger" type="button" onClick={(event) => { event.preventDefault(); this.setState({ showForm: false }) }}>Cancel</Button>
                            </Col>
                        </Form.Group>
                    </Form>
                )
                :

                <div className="video-desc">
                    <h4>{this.props.title}</h4>
                    <p>{this.props.content}</p>
                    {
                        this.props.is_editable ?
                            <Button onClick={() => { this.setState({ showForm: true }) }}>
                                Edit
                            </Button>
                            : null
                    }

                </div>


        );
    }
}
